module.exports = __webpack_public_path__ + "static/media/Moluscos.b1f9cba6.png";